import { render, staticRenderFns } from "./SoulpayRentability.vue?vue&type=template&id=6fa608a0"
import script from "./SoulpayRentability.vue?vue&type=script&lang=js"
export * from "./SoulpayRentability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports